import { forwardRef } from "react";
import PropTypes from "prop-types";
import MKSelectRoot from "./MKSelectRoot"; // Importing the styled Select component

// Main MKSelect component
const MKSelect = forwardRef(({ error, success, disabled, ...rest }, ref) => (
  <MKSelectRoot {...rest} ref={ref} ownerState={{ error, success, disabled }} />
));

// Setting default props for MKSelect
MKSelect.defaultProps = {
  error: false,
  success: false,
  disabled: false,
};

// PropTypes for MKSelect
MKSelect.propTypes = {
  error: PropTypes.bool,
  success: PropTypes.bool,
  disabled: PropTypes.bool,
};

export default MKSelect;